import ROUTES from './constants';

import BidSettings from '../../pages/BidSettings';
import Trade from '../../pages/Trade';
import Search from '../../pages/Search';
import Loading from '../../pages/RetailCreate/Loading';
import RoutesBuying from './RoutesBuying';
import RoutesSelling from './RoutesSelling';
import RoutesTiah from './RoutesTiah';
import PaymentsOnHold from '../../pages/PaymentsOnHold';
import OktaRedirect from '../../pages/OktaRedirect';
import Logout from '../../pages/Logout';
import RetailTools from '../../pages/RetailTools';
import RetailCreateRouteWrapper from '../../pages/RetailCreate/RetailCreateRouteWrapper';
import RetailVdpRouteWrapper from '../../pages/RetailVdp/RetailVdpRouteWrapper';

export const routes = [
  {
    path: [ROUTES.TRADE_DETAILS, ROUTES.TRADE_DETAILS.replace('?', '')],
    authenticated: true,
    Component: Trade
  },
  {
    path: [
      ROUTES.BUYING_ACTIVE,
      ROUTES.BUYING_UPCOMING,
      ROUTES.BUYING_PENDING,
      ROUTES.BUYING_CLOSING,
      ROUTES.BUYING_PURCHASE
    ],
    Component: RoutesBuying
  },
  {
    path: [
      ROUTES.SELLING_PARKED,
      ROUTES.SELLING_UPCOMING,
      ROUTES.SELLING_ACTIVE,
      ROUTES.SELLING_PENDING,
      ROUTES.SELLING_CLOSING,
      ROUTES.SELLING_WON,
      ROUTES.SELLING_ARRIVED,
      ROUTES.SELLING_DELIVERED,
      ROUTES.SELLING_LOST,
      ROUTES.SELLING_ADESA
    ],
    Component: RoutesSelling
  },
  {
    path: [ROUTES.SEARCH],
    authenticated: true,
    Component: Search
  },
  {
    path: [ROUTES.BID_SETTINGS],
    authenticated: true,
    Component: BidSettings
  },
  {
    path: [ROUTES.RETAIL_TOOLS],
    authenticated: true,
    Component: RetailTools
  },
  {
    path: [ROUTES.RETAIL],
    authenticated: true,
    Component: RetailCreateRouteWrapper
  },
  {
    path: [ROUTES.RETAIL_LOADING],
    authenticated: false,
    Component: Loading
  },
  {
    path: [ROUTES.RETAIL_PUBLIC],
    authenticated: false,
    Component: RetailVdpRouteWrapper
  },
  {
    path: [ROUTES.TIAH],
    Component: RoutesTiah
  },
  {
    path: [ROUTES.PAYMENTS_ON_HOLD],
    Component: PaymentsOnHold
  },
  {
    path: [ROUTES.OKTA_REDIRECT],
    authenticated: true,
    Component: OktaRedirect
  },
  {
    path: [ROUTES.LOGOUT],
    authenticated: true,
    Component: Logout
  }
];

export const redirect = [
  { path: ROUTES.LANDING, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.QA, to: ROUTES.TR4_QA, tr4: true },
  { path: ROUTES.HOME, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.CREATE, to: ROUTES.TR4_CREATE, tr4: true },
  { path: ROUTES.RESEARCH, to: ROUTES.TR4_RESEARCH, tr4: true },
  { path: ROUTES.BUYING, to: ROUTES.BUYING_ACTIVE, tr4: false },
  { path: ROUTES.BUYING_WON, to: ROUTES.TR4_BUY_WON, tr4: true },
  { path: ROUTES.BUYING_ARRIVED, to: ROUTES.TR4_BUY_ARRIVED, tr4: true },
  { path: ROUTES.BUYING_DELIVERED, to: ROUTES.TR4_BUY_DELIVERED, tr4: true },
  { path: ROUTES.SELLING, to: ROUTES.TR4_SELL_ACTIVE, tr4: true },
  { path: ROUTES.PROFILE, to: ROUTES.TR4_PROFILE, tr4: true },
  { path: ROUTES.ACCOUNT_PROFILE, to: ROUTES.TR4_ACCOUNT_PROFILE, tr4: true },
  { path: ROUTES.ACCOUNTING, to: ROUTES.TR4_ACCOUNTING, tr4: true },
  { path: ROUTES.SHIPPING, to: ROUTES.TR4_SHIPPING, tr4: true },
  { path: ROUTES.PAYMENTS, to: ROUTES.TR4_PAYMENTS, tr4: true },
  { path: ROUTES.REPORTS, to: ROUTES.TR4_REPORTS, tr4: true },
  { path: ROUTES.SETTINGS, to: ROUTES.TR4_SETTINGS, tr4: true },
  { path: ROUTES.SUPPORT, to: ROUTES.TR4_SUPPORT, tr4: true },
  { path: ROUTES.SWITCH_USER, to: ROUTES.TR4_SWITCH_USER, tr4: true },
  { path: ROUTES.PAYMENTS_ON_HOLD, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.TIAH, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.TIAH_DEALER_MAP, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.TIAH_MOBILE_NUMBER, to: ROUTES.TR4_ENDPOINT, tr4: true },
  { path: ROUTES.TIAH_MOBILE_VERIFICATION, to: ROUTES.TR4_ENDPOINT, tr4: true }
];

export const getRedirect = pathname =>
  redirect.find(({ path }) => {
    if (!path) return false;
    const routeParsedAsRegexTerm = `${path}`.replace(
      /\:[^[?|\/]*\??/gm, // eslint-disable-line
      '[^/]*'
    );
    const matches = pathname.match(new RegExp(`^${routeParsedAsRegexTerm}$`));
    return Array.isArray(matches) && matches.length > 0;
  });
